import { Modal } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";

const Block = ({
  // New API
  open,
  onCancel,
  onConfirm,
  loading,
  title,
  confirmText,
  // Backward-compat props
  modelType,
  handleSubmit,
  btnText,
  closeModal,
}) => {
  const handleClick = onConfirm || handleSubmit;
  const resolvedConfirmText = btnText || confirmText || "Confirm";
  const handleClose = onCancel || closeModal;

  return (
    <Modal
      className={`form-css-5 ${confirmText === "Log Out" ? "max-w-[300px]" : ""}`}
      // className={`form-css-5`}
      open={open}
      footer={null}
      onCancel={handleClose}
      title={<p className="font-abhaya text-3xl bg-transparent">{confirmText}</p>}
    >
      <div className="">
        <p
          // className={`w-full text-lg font-medium ${
          //   confirmText === "Log Out" ? "text-center" : ""
          // }`}
          className={`w-full text-left text-base mt-2 mb-4`}
        >
          {title}
        </p>
      </div>
      <div className="w-full flex justify-center">
        <PrimaryButton
          text={resolvedConfirmText}
          className="me-[30px]"
          onClick={handleClick}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default Block;
